import {useState} from 'react';
import React, {Component} from 'react';

import Input from './input-with-label';
import InputTextarea from './input-with-textarea';

import Checkbox from './checkbox';
import NavLink from '../react/nav-link';

import SeamApi from '../../lib/seam-api';
import OfficeApi from '../../lib/office-api';

import LabelContainer from '../react/label-container';

import Dropdown from '../react/select';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

const fields  = ['first_name', 'last_name', 'email', 'phone_number', 'type_id', 'type', 'message'];

const checkboxes = [
    {
        text: 'Please add me to DMC’s Mailing List',
        id: 1
    }
];

class SpaceEnquiry extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accept: false,
            acceptError : false,
            dateError : false,
            permissions: {},
            errors : {},
            success:  false,
            focusedInput: false,
            additional_passes: false,
        };
    }

    onChange(e) {
        this.setState({
            errors:  {
                ...this.state.errors,
                [e.target.name]: [],
            },
            [e.target.name] : e.target.value,
        }, () => {
            console.log(this.state)
        });
    }

    onStaffChange(e) {
        this.setState({
            errors:  {
                ...this.state.errors,
                staff_members: [],
            },
            staff_members : e.value,
        }, () => {
            console.log(this.state)
        });
    }

    formatParams() {
        let params = {
            source_distribution_id : 1,
            subject: 'Office space enquiry',
            message: 'Office space enquiry',
            contact_permissions : [],
            meta : {
                company_name : this.state.company_name,
                staff_members: this.state.staff_members,
                additional_passes: String(this.state.additional_passes),
            },
            type: 'office',
            type_id: this.props.officeId || '1',
        };

        fields.forEach((field) => {
           if(this.state.hasOwnProperty(field)) {
               console.log(this.state)
               if(this.state[field].length >= 1) {
                   params[field] = this.state[field];
               }
           }
        });


         _.each(this.state.permissions, (i, index) => {
             if(i === true) {
                 params.contact_permissions.push(parseInt(index));
             }
        });


        return params;

    }

    handleSubmit() {
        this.setState({ dateError: false });

        if(this.state.accept === false) {
            return this.setState({ acceptError : true });
        }

        this.setState({ acceptError : false });

        SeamApi.contacts().message(this.formatParams(), this.handleErrors.bind(this)).then(() => {

            let params = {
                success : true,
                company_name: '',
            };

            fields.forEach(field => {
                params[field] = '';
            });

            this.setState(params);
        });
    }

    handleErrors(data) {
        this.setState({errors : data});
    }

    getErrors(name) {
        return this.state.errors.hasOwnProperty(name) ? this.state.errors[name]  : [];
    }

    render() {
        return (
            <div className="overlay-arrange overlay-space-enquiry">
                <h1>ARRANGE A VISIT</h1>
                <form>
                    <div className="overlay__content">
                        <div className="overlay-arrange__left">
                            <h3>Overview</h3>

                            <img className="overlay-space-enquiry__office" src="/images/assets/background/office-background.png" />

                            <div class="office-page-hero__information">
                                <div class="office-page-hero-information__inner">
                                    <h2>{ this.props?.officeName }</h2>
                                    <div class="office-page-hero-information__building">{ this.props?.officeBuilding }</div>
                                </div>

                                <NavLink text={`Avaliable from £${this.props?.officePrice}pcm`}/>
                            </div>

                            <div class="office-page-hero__labels">
                                <div class="office-page-hero__label">
                                    <b>DESKS</b>
                                    <div class="office-page-hero-label__row" >
                                        <img src="/images/assets/icons/SVG/dmc-office-desks.svg"/>

                                        <p>{ this.props?.officeDesks }</p>
                                    </div>
                                </div>

                                <div class="office-page-hero__label">
                                    <b>FLOOR SIZE</b>
                                    <div class="office-page-hero-label__row" >
                                        <img src="/images/assets/icons/SVG/dmc-office-floor.svg"/><p>{ this.props?.officeSize }</p>
                                    </div>
                                </div>

                                <div class="office-page-hero__label">
                                    <b>LEVEL</b>
                                    <div class="office-page-hero-label__row" >
                                        <img src="/images/assets/icons/SVG/dmc-office-level.svg"/><p>{ this.props?.officeFloor }</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="overlay-arrange__right">
                            <h3>Your Enquiry</h3>
                            <Input name="first_name" value={this.state?.first_name} onChange={this.onChange.bind(this)} placeholder="Your First Name" errors={this.getErrors('first_name')}/>
                            <Input name="last_name" value={this.state?.last_name} onChange={this.onChange.bind(this)} placeholder="Your Last Name" errors={this.getErrors('last_name')}/>
                            <Input name="company_name" value={this.state?.company_name} onChange={this.onChange.bind(this)} placeholder="Your Business Name" errors={this.getErrors('company_name')}/>
                            <Input name="email" value={this.state?.email} onChange={this.onChange.bind(this)} placeholder="Email Address" errors={this.getErrors('email')}/>
                            <Input name="phone_number" value={this.state?.phone_number} onChange={this.onChange.bind(this)} placeholder="Telephone Number" errors={this.getErrors('phone_number')}/>
                            <InputTextarea name="message" value={this.state?.message} onChange={this.onChange.bind(this)} placeholder="Do you have any questions about this space?" errors={this.getErrors('message')}/>

                            <LabelContainer fill={true} label="Number of staff?">
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '20px',
                                    flexWrap: 'wrap',
                                }}>
                                    <Dropdown placeholder="Number of staff" onChange={this.onStaffChange.bind(this)} items={[
                                        {
                                            option: '1-10',
                                            value: '1-10',
                                        },
                                        {
                                            option: '11-25',
                                            value: '11-25',
                                        },
                                        {
                                            option: '26-50',
                                            value: '26-50',
                                        },
                                        {
                                            option: '51-100',
                                            value: '51-100',
                                        },
                                        {
                                            option: '101-150',
                                            value: '101-150',
                                        },
                                        {
                                            option: '151-200',
                                            value: '151-200',
                                        },
                                        {
                                            option: '201-250',
                                            value: '201-250',
                                        },
                                        {
                                            option: '250+',
                                            value: '250+',
                                        }
                                    ]}/>
                                    <div className="checkbox__outer">
                                        <Checkbox
                                            ariaLabelledby="label__privacy"
                                            checked={this.state.additional_passes}
                                            square={true}
                                            toggleCheckBox={() => this.setState({ additional_passes : !this.state.additional_passes })}/>
                                        <p id="label__privacy">I’ll need additional parking passes</p>
                                    </div>
                                </div>
                            </LabelContainer>

                            <div className="overlay__bottom overlay-arrange__bottom">
                                <div className='overlay-section__checkboxes'>

                                    { checkboxes.map(({text, id}, index) => {
                                        return (
                                            <div key={id} className="checkbox__outer">
                                                <Checkbox
                                                    ariaLabelledby="label__mail"
                                                    checked={this.state.permissions.hasOwnProperty(id) && this.state.permissions[id] === true}
                                                    square={true}
                                                    toggleCheckBox={() => this.setState({
                                                        permissions: Object.assign({}, this.state.permissions, {
                                                            [id]: !this.state.permissions[id]
                                                        })
                                                    })} />
                                                <p id="label_mail" >{text}</p>
                                            </div>
                                        )
                                    })}

                                    <div className="checkbox__outer">
                                        <Checkbox
                                            ariaLabelledby="label__privacy"
                                            checked={this.state.accept}
                                            square={true}
                                            toggleCheckBox={() => this.setState({ accept : !this.state.accept, acceptError: false, success: false })}/>
                                        <p id="label__privacy">I Accept the <a target={'_blank'} rel={'noreferrer'} href="https://www.barnsley.gov.uk/services/information-and-privacy/your-privacy/">privacy policy</a></p>
                                    </div>

                                    {this.state.acceptError && <div className="input-outer__errors"><p>Please accept our privacy policy</p></div> }
                                </div>
                                <div className="overlay__send">
                                    <NavLink text="BOOK" color="green" onClick={this.handleSubmit.bind(this)}/>
                                </div>
                            </div>

                            { this.state.success && !this.state.acceptError && <div className="overlay-speak__success">
                                Thank you for contacting us! Your enquiry will be seen to by our experience team and responded to shortly.
                            </div> }
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default SpaceEnquiry;
